import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TooltipOnEllipsis from '../tooltipOnEllipsis/tooltipOnEllipsis';
import Tooltip from '../tooltip/tooltip';
import { dataHooks } from './constants';

var getStyleFromProps = function getStyleFromProps(props) {
  return props.wasVisible ? props.wasVisibleStyle : {};
};

var getLabel = function getLabel(props) {
  return props.translateIfNeeded(props.label) + (props.selectedValueSuffix ? props.selectedValueSuffix : '');
};

var renderDropdownContent = function renderDropdownContent(props) {
  var tooltipContent = props.tooltipContent,
      getClassName = props.getClassName;
  var label = getLabel(props);
  return tooltipContent ? /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    dataHook: dataHooks.dropdownTooltip
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName('has-tooltip')
  }, label)) : /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    closeOnMouseClick: true
  }, label);
};

var DropDownOption = function DropDownOption(props) {
  var getClassName = props.getClassName,
      value = props.value,
      key = props.key,
      disabled = props.disabled,
      wasVisibleStyle = props.wasVisibleStyle,
      automationId = props.automationId,
      dataHook = props.dataHook,
      isSelectedElement = props.isSelectedElement,
      forceChildren = props.forceChildren,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName('control-dropdown-option-content'),
    value: value,
    key: key || value,
    disabled: disabled,
    style: wasVisibleStyle ? getStyleFromProps(props) : null,
    "data-aid": automationId,
    "data-hook": dataHook
  }, children && (!isSelectedElement || forceChildren) ? children : renderDropdownContent(props));
};

DropDownOption.displayName = displayNames.DROP_DOWN_OPTION;
DropDownOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isSelectedElement: PropTypes.bool,
  wasVisible: PropTypes.bool,
  wasVisibleStyle: PropTypes.object,
  selectedValueSuffix: PropTypes.string,
  forceChildren: PropTypes.bool,
  tooltipContent: PropTypes.node
};
DropDownOption.defaultProps = {
  disabled: false
};
export default compose(DropDownOption);